import {gql} from '@apollo/client';

export const CREATE_BCP_CHECK_USER_GROUP = gql`
    mutation CreateBcpCheckUserGroup($input: CreateCheckUserGroupInput!) {
        createBcpCheckUserGroup(input: $input) {
            success
            code
            message
            data {
                id
                groupName
            }
        }
    }
`;

export const UPDATE_BCP_CHECK_USER_GROUP = gql`
    mutation UpdateBcpCheckUserGroup($id: Long!, $input: CreateCheckUserGroupInput!) {
        updateBcpCheckUserGroup(id: $id, input: $input) {
            success
            code
            message
        }
    }
`;

export const DELETE_BCP_CHECK_USER_GROUP = gql`
    mutation DeleteBcpCheckUserGroup($id: Long!) {
        deleteBcpCheckUserGroup(id: $id) {
            success
            code
            message
        }
    }
`;
